export {
  API_ENTITY_SAVE_TIMEOUT_MS as AUDIT_SAVE_TIMEOUT_MS,
  API_ENTITY_SAVE_TIMEOUT_MESSAGE as AUDIT_SAVE_TIMEOUT_MESSAGE
} from './api-save-timeout.constants';

export const AUDIT_SAVE_SUCCESS_MESSAGE = 'Save successful!';
